import { lazy } from "react";
import Loadable from "../components/Loadable";
import { authRoles } from "../auth/authRoles";

const Dashboard = Loadable(lazy(() => import("../views/dashboard")));
const RequestsListToChangePhoneNumber = Loadable(lazy(() => import("../views/changePhoneNumber/index")));
const ViewRequest = Loadable(lazy(() => import("../views/changePhoneNumber/viewRequest")));

const adminRoutes = [
  { path: "/dashboard", element: <Dashboard />, auth: authRoles.admin },
  { path: "/requests-list-to-change-phone-number", element: <RequestsListToChangePhoneNumber />, auth: authRoles.admin },
  { path: "/request-confirmation/:id/:requestId/:action", element: <ViewRequest />, auth: authRoles.admin },
];

export default adminRoutes;